import { features } from '@/mocks/homeData';

export default function FeatureGridSection() {
  return (
    <section id="ozellikler" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-semibold mb-4">
            Özellikler
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Kurban, satış, cari ve operasyon için kurumsal yönetim altyapısı.
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            PostgreSQL altyapılı CiftlikWeb; mobil uyumlu bulut tabanlı yazılım üzerinde kurbanlık satış ve hisse takip programı, çiftlik cari ve müşteri takip sistemi ile dijital kurban kesim sıramatiğini tek merkezde birleştirir.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-xl p-6 border transition-all duration-300 group flex gap-4 ${
                item.title.includes('Kurban') || item.title.includes('Havale') || item.title.includes('Taşıma') || item.title.includes('Müşteri Portalı')
                  ? 'border-accent-200/50 hover:border-accent-400/70'
                  : 'border-background-200/70 hover:border-primary-200/50'
              }`}
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex-shrink-0 flex items-center justify-center rounded-lg transition-colors duration-300 ${
                item.title.includes('Kurban') || item.title.includes('Havale') || item.title.includes('Taşıma') || item.title.includes('Müşteri Portalı')
                  ? 'bg-accent-50 group-hover:bg-accent-100'
                  : 'bg-primary-50 group-hover:bg-primary-100'
              }`}>
                <i className={`${item.icon} text-lg md:text-xl ${
                  item.title.includes('Kurban') || item.title.includes('Havale') || item.title.includes('Taşıma') || item.title.includes('Müşteri Portalı')
                    ? 'text-accent-500'
                    : 'text-primary-500'
                }`}></i>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-base text-foreground-950 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
